import { Component, inject, Input, signal, WritableSignal } from '@angular/core';
import { Materiel } from '../../models/materiel';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { TuiAppearance, TuiSurface } from '@taiga-ui/core';
import { TuiCardLarge, TuiCardMedium } from '@taiga-ui/layout';
import { PhotoService } from '../../services/photo.service';

@Component({
  selector: 'app-materiel-data',
  standalone: true,
  imports: [TuiCardLarge, TuiSurface, TuiAppearance],
  templateUrl: './materiel-data.component.html',
  styleUrl: './materiel-data.component.scss'
})
export class MaterielDataComponent {
  @Input() materiel: Materiel | undefined;
  sanitizer = inject(DomSanitizer);
  photoService = inject(PhotoService);
  photoUrl0: WritableSignal<SafeResourceUrl | undefined> = signal(undefined);


  ngOnInit(): void {
    if (this.materiel) {

      this.photoService.pullFile(this.materiel?.id).subscribe({
        next: (blob) => {
          // Créer une URL sécurisée
          const url: SafeResourceUrl =
            this.sanitizer.bypassSecurityTrustResourceUrl(
              URL.createObjectURL(blob)
            );

          // Passer cette URL au `pdfService`
          this.photoUrl0.set(url);

        },
        error: (err) => {
          console.error('Erreur lors du chargement du PDF :', err);
        },
      });

    }
  }

  createImageFromBlob(image: Blob | undefined): SafeUrl | undefined {
    if (image) {
      const objectURL = URL.createObjectURL(image);
      return this.sanitizer.bypassSecurityTrustUrl(objectURL);
    }
    return undefined;
  }
}